import type { TranslationInterface } from '.';

export const EnglishLanguage: TranslationInterface = {
  write_a_message_placeholder: 'Write a message...',
  your_issue_has_been_resolved: 'Your issue has been resolved!',
  new_conversation: 'New conversation',
  welcome_screen_title: 'Welcome to our support chat',
  welcome_screen_description:
    "We're here to help! Start a conversation and we'll get back to you as soon as possible.",
  your_name_placeholder: 'Your name',
  your_email_placeholder: 'Your email address',
  start_chat_button: 'Talk to support',
  start_chat_button_loading: 'Connecting...',
  i_need_more_help: 'I need more help',
  this_was_helpful: 'This was helpful',
  optional: 'Optional',
  no_conversations_yet: 'No conversations yet',
  back_to_conversations: 'Back to conversations',
  closed_conversations: 'Closed conversations',
  csat_title: 'How was your conversation?',
  csat_submitted_title: 'You rated the conversation as',
  csat_feedback_placeholder: 'Tell us more... (optional)',
  follow_up_placeholder: 'Follow up…',
  companion_layout_label: 'Layout',
  companion_layout_floating: 'Floating',
  companion_layout_sidebar: 'Sidebar',
  companion_layout_fullscreen: 'Fullscreen',
  companion_close_chat: 'Close {title}',
  companion_close: 'Close',
  companion_switch_chat: 'Switch chat',
  companion_viewing: 'Viewing',
  companion_working: 'Working',
  companion_open: 'Open',
  companion_closed: 'Closed',
  companion_draft: 'Draft',
  companion_chats: 'Active sessions',
  companion_chat_number: 'Chat {count}',
  companion_active_chats: '{count} active sessions',
  companion_other_sessions: 'Other open sessions: {count}',
  companion_working_chats: '{count} working',
  unread_sessions: '{count} unread',
  companion_history: 'Conversation history',
  companion_expand_chat: 'Expand chat',
  companion_sidebar_dock_label: 'Dock',
  companion_sidebar_side_label: 'Side',
  companion_sidebar_left: 'Left',
  companion_sidebar_right: 'Right',
  companion_resize_chat: 'Resize chat',
  scroll_to_bottom: 'Scroll to bottom',
  thinking: 'Thinking…',
  running: 'Running…',
  steps: 'steps',
  step_arguments: 'Arguments',
  step_result: 'Result',
  attach_files:
    'Attach images, videos, PDFs, or spreadsheets (maximum size 25 MB)',
  mark_page_active: 'Click anything on the page to mark it — Esc to cancel',
  mark_page: 'Mark something on the page to ask about it',
  stop_response: 'Stop response',
  copy_reply: 'Copy reply',
  mentions_empty: 'No matches',
  copied: 'Copied',
  send_message: 'Send message',
  upload_failed: 'Failed to upload: {error}',
  remove_attachment: 'Remove attachment',
  json_no_items: 'No items',
  json_no_data: 'No data',
  json_no_chart_data: 'No data to chart',
  json_unsupported: 'Unsupported: {type}',
  json_see_less: 'See less',
  json_phone_agent: 'Phone agent',
  json_phone_agent_test: 'Test via web',
  page_context_remove: 'Remove page context',
  json_see_more: 'See {count} more',
  queued_label: '{count} Queued',
  remove_queued_message: 'Remove queued message',
  send_queued_now: 'Send queued messages now',
  turn_failed_message: 'Something went wrong and the reply didn’t arrive.',
  turn_failed_retry: 'Try again',
  page_mark_hint: 'Click anything to mark it',
  page_mark_escape: 'Esc',
  page_mark_shape_box: 'Box',
  page_mark_shape_circle: 'Circle',
  page_mark_shape_arrow: 'Arrow',
  page_mark_shape_bracket: 'Bracket',
  page_mark_shape_underline: 'Underline',
  page_mark_shape_highlight: 'Highlight',
  page_mark_shape_strike_through: 'Strike through',
  page_mark_shape_crossed_off: 'Cross out',
  page_mark_shape_aria: 'Mark shape: {shape}',
  page_mark_note_placeholder: 'Add a note… (Enter to attach)',
  page_mark_attach: 'Attach mark',
  page_mark_remove: 'Remove {label}',
  page_mark_region: 'Marked region',
  page_mark_default_message: 'What is this?',
  file_rejected: 'The file type is unsupported or the file is too large.',
  dictate: 'Dictate',
  stop_dictation: 'Stop dictating',
  dictation_mic_blocked: 'Allow microphone access to dictate',
  dictation_unavailable: 'Dictation is unavailable right now',
  questions_back: 'Back',
  questions_next: 'Next',
  questions_send: 'Send',
  questions_type_answer: "I'll type it",
  questions_answer_placeholder: 'Type your answer…',
  close_conversation_title: 'Close conversation',
  close_conversation_description:
    'Are you sure you want to close this conversation?',
  close_conversation_cancel: 'No',
  close_conversation_confirm: 'Yes',
  dialog_close: 'Close',
  zoom_in: 'Zoom in',
  zoom_out: 'Zoom out',
  reset_zoom: 'Reset zoom',
  support_chat_aria_label: 'Support chat',
};
